var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Html5Qrcode } from "html5-qrcode";
let scanner = null;
let Scanner = class Scanner extends Vue {
    constructor() {
        super(...arguments);
        this.error = false;
        this.processing = false;
    }
    mounted() {
        this.launch();
    }
    beforeDestroy() {
        return __awaiter(this, void 0, void 0, function* () {
            if (scanner)
                yield scanner.stop();
            scanner = null;
        });
    }
    launch() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                scanner = new Html5Qrcode("qr-reader", undefined);
                yield scanner.start({ facingMode: { exact: "environment" } }, { fps: 10, qrbox: 250, aspectRatio: 1.2 }, msg => this.onScan(msg), undefined);
                // Fix shade
                var q = document.getElementById("qr-shaded-region");
                var v = document.querySelector("video");
                if (q && v)
                    q.style.height = getComputedStyle(v, null).height;
            }
            catch (e) {
                this.error = true;
            }
            // 開啟底下這一行可以進行偵錯測試
            // setTimeout(()=>this.scanCore("83886335"),3000);
        });
    }
    onScan(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.processing)
                return;
            this.processing = true;
            yield this.callback(msg);
            this.processing = false;
        });
    }
};
__decorate([
    Inject()
], Scanner.prototype, "alert", void 0);
__decorate([
    Inject()
], Scanner.prototype, "confirm", void 0);
__decorate([
    Prop()
], Scanner.prototype, "callback", void 0);
Scanner = __decorate([
    Component
], Scanner);
export default Scanner;
